import script from "./MallBottomNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallBottomNav.vue?vue&type=script&setup=true&lang=ts"

import "./MallBottomNav.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__